import { ComponentPropsWithoutRef, forwardRef } from 'react'
import BaseInput from './BaseInput'
import styles from '../../styles/common/Input.module.scss'

interface ModalInputProps extends ComponentPropsWithoutRef<'input'> {
  label?: string
  type?: string
  isError?: boolean
  required?: boolean
}

const ModalInput = forwardRef<HTMLInputElement, ModalInputProps>(
  ({ className, label, required, ...props }, ref) => {
    return (
      <div className={styles.inputWrapper}>
        {label && (
          <label className={styles.inputLabel}>
            {label}
            {required && <span className={styles.required}>*</span>}
          </label>
        )}
        <BaseInput
          ref={ref}
          className={`${styles.modalInputContainer} ${className || ''}`}
          {...props}
        />
      </div>
    )
  }
)

ModalInput.displayName = 'ModalInput'

export default ModalInput
